import { useContext } from 'react'

import GlobalContentContext from '../../contexts/GlobalContentContext'

export function usePageContext() {
  const globalContent = useContext(GlobalContentContext)
  return globalContent?.pageContext ?? null
}
